export default __webpack_public_path__ + "static/media/miguel-lopes-9.93d0c98d.jpg";